import SearchableDropdown from "../../common/DropdownSearchable";
import InputWithLabel from "../../common/InputWithLabel";
import { SPECIALTIES } from "@neum/frontend-shared/constants/doctorData";
import { toTitleCase } from "@neum/frontend-shared/utils/textUtils";

export interface OnboardInfo {
  specialty: string;
  specialtyInput: string;
}

const OnboardingQuestions = ({
  onboardInfo,
  handleSetOnboardInfo,
}: {
  onboardInfo: OnboardInfo;
  handleSetOnboardInfo: (info: OnboardInfo) => void;
}) => {
  return (
    <div className="mt-4 space-y-6">
      <p className="text-sm text-gray-500">Let’s personalize things for you</p>
      {/* Specialty Selection */}
        <SearchableDropdown<string>
          items={Object.values(SPECIALTIES)}
          label="What is your primary specialty?"
          selectedItem={onboardInfo.specialty}
          setSelectedItem={(specialty) =>
            handleSetOnboardInfo({
              ...onboardInfo,
              specialty: specialty as string,
            })
          }
          displayValue={(item) => (item ? toTitleCase(item) : "")}
          filterFunction={(item, query) =>
            item.toLowerCase().includes(query.toLowerCase())
          }
          placeholder="General Practice, Neurology, etc."
        />

      {/* custom input for other specialty */}
      {onboardInfo.specialty === SPECIALTIES.OTHER && (
        <InputWithLabel
          value={onboardInfo.specialtyInput}
          setValue={(value) =>
            handleSetOnboardInfo({
              ...onboardInfo,
              specialtyInput: value as string,
            })
          }
          label="What is your specialty?"
          placeholder="General Practice, Neurology, etc."
          maxLength={80}
        />
      )}
    </div>
  );
};

export default OnboardingQuestions;
